import {
    faClipboardList,
    faEdit,
    faEye,
    faPlus,
    faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useReducer, useState } from "react";
import { ColumnDescription } from "react-bootstrap-table-next";
import Swal from "sweetalert2";
import ModalComponent from "../../../Components/Modais";
import { IComponentModal } from "../../../Components/Modais/IModalComponent";
import Table from "../../../Components/Table";
import LeiaMais from "../../../Components/Utils/LeiaMais";
import {
    DeletarFormController,
    ListarFormulariosController,
} from "../../../Controllers/Geral/Formularios/FormulariosControllers";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import { IListarFormularios } from "../../../Interfaces/Geral/Formularios/FormulariosInterface";
import CadastrarFormulario from "./CadastrarEditarFormulario";
import EditarFormulario from "./EditarFomulario";
import VisualizarFormulario from "./VisualizarFormulario";

interface IEditarFormState {
    idFormulario: number;
    recemCriado: boolean;
}

function editarFormReducer(
    current: IEditarFormState,
    action: IEditarFormState | number
) {
    if (typeof action === "number") {
        return {
            idFormulario: action,
            recemCriado: false,
        };
    } else {
        return action;
    }
}

export default function Formularios() {
    const {
        value: ListarFormularios,
        loading: ListarFormulariosLoading,
        execute: updateList,
    } = useAsyncEffect(ListarFormulariosController);

    const [formularioEmEdicao, setFormularioEmEdicao] = useReducer(
        editarFormReducer,
        {
            idFormulario: 0,
            recemCriado: false,
        }
    );
    const [modal, setModal] = useState<IComponentModal>();
    const [show, setShow] = useState(false);

    useEffect(() => {
        if (formularioEmEdicao.idFormulario !== 0) {
            setShow(true);
            setModal({
                noHeader: true,
                noBody: true,
                noFooter: true,
                IconHeader: faClipboardList,
                onClose: () => setFormularioEmEdicao(0),
                Component: () => (
                    <EditarFormulario
                        idFormulario={formularioEmEdicao.idFormulario}
                        recemCriado={formularioEmEdicao.recemCriado}
                        setModal={setModal}
                        setShow={setShow}
                        updateList={updateList}
                    />
                ),
                size: "lg",
            });
        }
    }, [formularioEmEdicao, updateList]);

    const tableviewColumns: Array<ColumnDescription<IListarFormularios>> = [
        {
            dataField: "DS_FORMULARIO",
            text: "Formulário",
            formatter: (c, row) => (
                <div className="d-flex flex-md-nowrap flex-wrap justify-content-between p-3">
                    <div>
                        <h6>{c}</h6>
                        <div>
                            <LeiaMais charLimit={100}>
                                {row.DS_INFORMACOES}
                            </LeiaMais>
                        </div>
                    </div>
                    <div className="Button-Tools">
                        <button
                            className="btn btn-outline-info font-weight-bold mr-2"
                            onClick={() => {
                                setShow(true);
                                setModal({
                                    headerComponent: "Visualizar Formulário",
                                    IconHeader: faEye,
                                    Component: () => (
                                        <VisualizarFormulario
                                            setShow={setShow}
                                            idFormulario={row.ID_FORMULARIO}
                                            visualizandoFormRespondido={false}
                                        />
                                    ),
                                    size: "lg",
                                });
                            }}
                        >
                            <FontAwesomeIcon icon={faEye} size="lg" />{" "}
                            <span className="d-none d-sm-block">
                                Visualizar
                            </span>
                        </button>
                        <button
                            className="btn btn-outline-primary font-weight-bold mr-2 "
                            onClick={() => {
                                setFormularioEmEdicao(row.ID_FORMULARIO);
                            }}
                        >
                            <FontAwesomeIcon icon={faEdit} size="lg" />{" "}
                            <span className="d-none d-sm-block">Editar</span>
                        </button>
                        <button
                            className="btn btn-outline-danger font-weight-bold mr-2"
                            onClick={() => {
                                Swal.fire({
                                    title: "Deseja apagar este formulário?",
                                    icon: "info",
                                    buttonsStyling: false,
                                    confirmButtonText:
                                        "<i class='la la-check'></i> Sim!",
                                    showCancelButton: true,
                                    cancelButtonText:
                                        "<i class='la la-thumbs-down'></i> Não",
                                    customClass: {
                                        confirmButton:
                                            "btn btn-outline-success",
                                        cancelButton: "btn btn-default",
                                    },
                                }).then((result) => {
                                    /* Read more about isConfirmed, isDenied below */
                                    if (result.isConfirmed) {
                                        DeletarFormController(
                                            row.ID_FORMULARIO
                                        ).then((response) => {
                                            updateList();
                                        });
                                    }
                                });
                            }}
                        >
                            <FontAwesomeIcon icon={faTrash} size="lg" />{" "}
                            <span className="d-none d-sm-block">Excluir</span>
                        </button>
                    </div>
                </div>
            ),
        },
    ];

    return (
        <div className="card card-custom">
            <div className="card-header card-header-tabs-line d-flex align-items-center">
                <h3 className="card-title align-items-start ">
                    <span className="card-label font-weight-bolder text-dark gruposTitle">
                        Formulários
                    </span>
                </h3>
                <div className="card-toolbar">
                    <button
                        type="button"
                        className="btn btn-success font-weight-bold mr-2"
                        onClick={() => {
                            setShow(true);
                            setModal({
                                headerComponent: "Criar Formulário",
                                IconHeader: faClipboardList,
                                Component: () => (
                                    <CadastrarFormulario
                                        then={(id) => {
                                            setFormularioEmEdicao({
                                                idFormulario: id,
                                                recemCriado: true,
                                            });
                                            setShow(false);
                                            updateList();
                                        }}
                                    />
                                ),
                                size: "lg",
                            });
                        }}
                    >
                        <FontAwesomeIcon icon={faPlus} size="lg" /> Novo
                        Formulário
                    </button>
                </div>
            </div>

            <div className="mt-10">
                {ListarFormularios ? (
                    <Table
                        wrapperClasses="mw-100 custom-scroll"
                        columns={tableviewColumns}
                        data={ListarFormularios}
                        loading={ListarFormulariosLoading}
                        keyField="ID_FORMULARIO"
                        noDataIndication={() => (
                            <div className="text-black-50 text-center">
                                Nenhum Formulário Encontrado
                            </div>
                        )}
                        noHover
                        noSearch
                        bordered={false}
                        striped={true}
                        rowClasses={"rowClasses"}
                        center={true}
                    />
                ) : null}
            </div>

            <ModalComponent
                show={show}
                setShow={setShow}
                ModalComponent={modal}
            />
        </div>
    );
}
